<template>
  <iframe
    class="sigma-dashboard"
    frameBorder="0"
    :src="embedUrl"
    :title="t('dashboards.dashboards')"
  />
</template>

<script lang="ts" setup>
import { useEventListener } from '@vueuse/core';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  embedUrl: {
    type: String,
    default: () => '',
  },
});
const { embedUrl } = toRefs(props);
const emit = defineEmits<{
  (event: 'event', payload: MessageEvent): void;
}>();

useEventListener(window, 'message', (event: MessageEvent) => {
  emit('event', event);
});
const { t } = useI18n();
</script>

<style>
.sigma-dashboard {
  display: block;
  height: 100%;
  width: 100%;
}
</style>
